import { ProgressLoaderAssurantService } from '../../../core/services/progress-loader-assurant.service';
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
  selector: 'assurant-loader',
  templateUrl: './assurant-loader.component.html',
  styleUrls: ['./assurant-loader.component.scss']
})
export class AssurantLoaderComponent implements OnInit, OnDestroy {

  @Input()
  showProgress =false;
  @Input()
  message = '';
  show = false;
  private subscription: Subscription;
  constructor(private loaderService: ProgressLoaderAssurantService) {}
  ngOnInit() {
    this.subscription = this.loaderService.loaderState.subscribe(value => {
      this.show = value.show;
    });
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
